import { sessionQueryOptions } from '@pwa/queries/auth/session';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(auth)')({
	beforeLoad: async ({ context }) => {
		const { queryClient } = context;
		const session = await queryClient.fetchQuery(sessionQueryOptions);
		if (session.data) {
			throw redirect({
				to: '/',
				replace: true,
			});
		}
	},
	component: Layout,
});

function Layout() {
	return (
		<div className='bg-background flex min-h-svh flex-col items-center justify-center gap-6 p-4 md:p-10'>
			<div className='flex w-full max-w-sm flex-col gap-6'>
				<Outlet />
			</div>
		</div>
	);
}
